    <div class="card-body">
        <div class="scrollnavbar card-header d-flex justify-content-between align-items-center flex-wrap p-2">
            <button class="scroll-btn" (click)="scrollLeft()" [disabled]="isAtLeft">
            ◀
            </button>
            <div class="nav-wrapper" #scrollContainer>
            <ul class="nav" id="j-pills-tab" role="tablist" ngbNav
                    #nav="ngbNav"
                    [(activeId)]="active"
                    (navChange)="onTabChange($event)" [(activeId)]="active" >
                    <li class="nav-item" *ngFor="let items of configuration" [ngbNavItem]="items.id">
                    <a class="nav-link" ngbNavLink>{{items.name}}</a>
                    <ng-template ngbNavContent>
                        <div class="tab-pane fade show" id="j-pills-web-designer" role="tabpanel"
                            aria-labelledby="j-pills-web-designer-tab">
                            <div *ngIf="isReprintReceiptTab && shouldShowTable" class="d-flex justify-content-between align-items-center mb-2 px-1">
                                <span class="badge bg-light text-dark border">{{ reprintBadgeText }}</span>
                                <button class="btn btn-success d-flex align-items-center gap-1 px-3 py-1 fw-bold" (click)="printSelectedReceipts()">
                                    <i class="fa fa-print"></i> {{ reprintButtonLabel }}
                                </button>
                            </div>

                            <!-- Empty state when load_after_filter is active and filter not yet applied -->
                            <div class="row justify-content-center my-4" *ngIf="!shouldShowTable">
                                <div class="col-12 text-center py-4">
                                    <img src="assets/DashboardIcon/applyfilters.svg" alt="Apply Filters" height="250px" width="350px">
                                    <p class="text-muted mt-2 fw-semibold">Please apply filters to load data</p>
                                </div>
                            </div>

                            <ng-container *ngIf="shouldShowTable">
                                <app-table
                                [config]="true"
                                [csv]="currentActiveCsv"
                                [pdf]="currentActivePdf"
                                [TableHeader]="table_header || items.name"
                                modalId="add{{getModalKey(items)}}"
                                [ExportFileName]="items.name"
                                [addApplication]="currentActiveAdd"
                                [addRouteUrl]="currentActiveAddRouteUrl"
                                (addRouteRequested)="navigateToAddRoute()"
                                (columnFormSubmitted)="onColumnFormSubmitted($event)"
                                buttonTitle='New Record'
                                [pageNation]="pageNation"
                                [paginationPageSizeSelector]="[10,20,50]"
                                (onPageChange)="handlePageChange($event)"
                                [maxRowCount]="totalcount">
                                </app-table>
                            </ng-container>
                            <app-form-modal [FormArray]="addFormArray.length ? addFormArray :[]" [Multiplefields]=true modalId="add{{getModalKey(items)}}" Modaltitle="Create New Records" [header]="'Add New Records'" leftButtonTitle="Cancel" rightButtonTitle="Add" (fomrresponse)="AddData($event,items.apiUrl)" ></app-form-modal>
                            <app-form-modal [FormArray]="editFormArray.length ? editFormArray : []" [Multiplefields]=true modalId="edit{{getModalKey(items)}}" Modaltitle="Edit Records" [header]="'Edit Records'" leftButtonTitle="Cancel" rightButtonTitle="Edit" (fomrresponse)="EditData($event,items.apiUrl)" ></app-form-modal>                        </div>
                    </ng-template>
                </li>
            </ul>
            </div>
            <button class="scroll-btn" (click)="scrollRight()" [disabled]="isAtRight">
            ▶
            </button>
        </div>
        <div *ngIf="hasFilterBar" class="w-100 p-2">
          <app-filter-select
            [showSites]="currentFilterConfig.showSites"
            [SiteOnly]="currentFilterConfig.SiteOnly"
            [showLocation]="currentFilterConfig.showLocation"
            [FromToLocation]="currentFilterConfig.FromToLocation"
            [SingleLocationDropdown]="currentFilterConfig.SingleLocationDropdown"
            [showDaterange]="currentFilterConfig.showDaterange"
            [showSingleDate]="currentFilterConfig.showSingleDate"
            [Month_Year]="currentFilterConfig.Month_Year"
            [Month_Range]="currentFilterConfig.Month_Range"
            [Date_Time]="currentFilterConfig.Date_Time"
            [Date_Flat]="currentFilterConfig.Date_Flat"
            [AllSelection]="currentFilterConfig.AllSelection"
            [showsubtype]="currentFilterConfig.showsubtype"
            [showappliances]="currentFilterConfig.showappliances"
            [showBillNo]="currentFilterConfig.showBillNo"
            [Hours]="currentFilterConfig.Hours"
            [search]="currentFilterConfig.search"
            [placeholder]="currentFilterConfig.placeholder"
            [filterConfig]="currentFilterConfig.filterConfig"
            (filtersApplied)="handleFilterApplied($event)"
            (showTable)="handleFilterReset($event)">
          </app-filter-select>
        </div>

        <div class="card-body px-0 pb-0">
            <div class="tab-content" id="j-pills-tabContent">
                <div [ngbNavOutlet]="nav" class="ms-2"></div>
            </div>
        </div>
    </div>
